import React, { type JSX } from "react";
import { SupText, SupHeading } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

import { TxStatus } from "../types";

export interface TxNotificationProps {
  className?: string;
  status: TxStatus;
  style?: "info" | "success" | "warning" | "error" | "active";
  title: string;
  description: string;
  children?: JSX.Element;
}

const statuses = {
  processing: "bg-info-50 text-info-800",
  confirmed: "bg-success-50 text-success-900",
  stuck: "bg-warning-50 text-warning-900",
  reverted: "bg-error-50 text-error-925",
  skipped: "bg-primary-200 text-neutral-600",
} as const;

const styles = {
  info: "bg-info-50 text-info-800",
  success: "bg-success-50 text-success-900",
  warning: "bg-warning-50 text-warning-900",
  error: "bg-error-50 text-error-925",
  active: "bg-primary-200 text-neutral-600",
} as const;

export function SupTxNotification({ className, status, style, title, description, children }: TxNotificationProps) {
  return (
    <div className={twMerge("p-4 text-center", style ? styles[style] : statuses[status], className)}>
      <SupText as="h3" variant="subtitle1" className="flex flex-col items-center justify-center gap-2 mb-4 md:flex-row">
        <SupHeading as="span" variant="h6" weight="bold">
          {status}
        </SupHeading>
        {title}
      </SupText>

      <SupText variant="body2" className={children ? "mb-4" : ""}>
        {description}
      </SupText>

      {children && <div className="flex justify-center">{children}</div>}
    </div>
  );
}
